__turbopack_context__.v({
  "className": "playfair_display_e6ce5d21-module__aqVYFG__className",
});
